import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FileUploadControl, FileUploadValidators, FileUploadModule } from '@iplab/ngx-file-upload';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KnBrNacTemplateModel } from 'src/app/models/knbr-nac-template.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { environment } from 'src/environments/environment';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-kn-br-update-template-dialog',
    templateUrl: './kn-br-update-template-dialog.component.html',
    styleUrls: ['./kn-br-update-template-dialog.component.scss'],
    imports: [FileUploadModule, TranslatePipe]
})
export class KnBrUpdateTemplateDialogComponent implements OnInit {
  public fileUploadControl = new FileUploadControl()
    .setListVisibility(false)
    .setValidators([FileUploadValidators.filesLimit(1), Validators.required]);

  documentTypes = '.csv';
  constructor(protected activeModal: NgbActiveModal, protected knBrCommonService: KnBrCommonService) {}
  baseURL = environment.BASEURL;
  @Input() templateData: KnBrNacTemplateModel;

  ngOnInit(): void {}

  dismiss() {
    this.activeModal.dismiss();
  }

  update() {
    if (this.fileUploadControl.value.length > 0) {
      const formData: FormData = new FormData();
      formData.append('attachment', this.fileUploadControl.value[0]);
      this.knBrCommonService.updateNacTemplate(this.templateData.templateName, formData);
      this.activeModal.close();
    }
  }
}
